// components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section about-us">
          <h3>Luxury 360 Suite</h3>
          <p>
            Your perfect getaway in Abuja, Nigeria.
          </p>
        </div>
        <div className="footer-section quick-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#rooms">Rooms</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-section contact-info">
          <h3>Contact Info</h3>
          <p>Abuja, Federal Capital Territory, Nigeria</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Luxury 360 Suite. All rights reserved.</p>
        {/* <p>Designed by [Your Name/Company]</p> */}
      </div>
    </footer>
  );
}

export default Footer;
